<section class="gcp-log-page" [class.query-is-collapsed]="queryCollapsed" [testId]="'gcp-log-list'">
  <header class="gcp-log-toolbar" testId="gcp-log-toolbar">
    <div class="gcp-log-heading">
      <div class="gcp-log-title-line">
        <span class="gcp-log-title-icon"><i nz-icon nzType="cloud-server"></i></span>
        <div>
          <h2 testId="gcp-log-title">{{ 'log.gcp.title' | i18n }}</h2>
          <p>{{ 'log.gcp.environment-hint' | i18n }}</p>
        </div>
      </div>
      <span class="gcp-log-range-note"><i nz-icon nzType="clock-circle"></i>{{ 'log.gcp.range-hint' | i18n }}</span>
    </div>
    <div class="gcp-log-actions">
      <button nz-button nzType="default" type="button" (click)="resetFilters()" [disabled]="loading" testId="gcp-log-reset-button">
        <i nz-icon nzType="reload"></i>{{ 'log.reset' | i18n }}
      </button>
      <button nz-button nzType="primary" type="button" (click)="search()" [nzLoading]="loading" testId="gcp-log-search-button">
        <i nz-icon nzType="search"></i>{{ 'log.search' | i18n }}
      </button>
    </div>
  </header>

  <section class="gcp-log-query" aria-labelledby="gcp-log-query-title" testId="gcp-log-query-section">
    <div class="gcp-log-section-heading">
      <div>
        <h3 id="gcp-log-query-title">{{ 'log.gcp.query-title' | i18n }}</h3>
        <p *ngIf="!queryCollapsed">{{ 'log.gcp.query-description' | i18n }}</p>
        <p class="gcp-log-query-summary" *ngIf="queryCollapsed">{{ getFilterSummary() }}</p>
      </div>
      <div class="gcp-log-query-heading-actions">
        <span class="gcp-log-filter-count" *ngIf="hasSearched">{{ 'log.gcp.latest-query' | i18n }}</span>
        <button
          nz-button
          nzType="text"
          type="button"
          class="gcp-log-collapse-button"
          (click)="toggleQuery()"
          [attr.aria-expanded]="!queryCollapsed"
          [attr.aria-label]="(queryCollapsed ? 'log.gcp.expand-query' : 'log.gcp.collapse-query') | i18n"
          testId="gcp-log-toggle-query-button"
        >
          <i nz-icon [nzType]="queryCollapsed ? 'down' : 'up'"></i>
          {{ (queryCollapsed ? 'log.gcp.expand' : 'log.gcp.collapse') | i18n }}
        </button>
      </div>
    </div>
    <div class="gcp-log-query-content" [class.is-collapsed]="queryCollapsed">
      <div class="gcp-log-filters">
        <label class="gcp-log-time-filter">
          <span>{{ 'log.gcp.time-range' | i18n }}</span>
          <nz-range-picker
            [ngModel]="[filters.startTime, filters.endTime]"
            nzShowTime
            [nzAllowClear]="false"
            [nzDisabled]="loading"
            (ngModelChange)="onTimeRangeChange($event)"
            testId="gcp-log-time-range-picker"
          />
        </label>
        <label>
          <span>{{ 'log.gcp.service-name' | i18n }}</span>
          <nz-input-group [nzSuffix]="clearServiceNameTpl" [testId]="'gcp-log-service-input-group'">
            <input
              nz-input
              [(ngModel)]="filters.serviceName"
              [placeholder]="'log.gcp.service-placeholder' | i18n"
              testId="gcp-log-service-input"
            />
            <ng-template #clearServiceNameTpl>
              <span
                *ngIf="filters.serviceName"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="filters.serviceName = ''"
                testId="gcp-log-service-clear-icon"
              ></span>
            </ng-template>
          </nz-input-group>
        </label>
        <label>
          <span>{{ 'log.gcp.severity' | i18n }}</span>
          <nz-select
            [(ngModel)]="filters.severity"
            nzAllowClear
            [nzPlaceHolder]="'log.gcp.all-severity' | i18n"
            testId="gcp-log-severity-select"
          >
            <nz-option *ngFor="let severity of severityOptions" [nzValue]="severity" [nzLabel]="severity" />
          </nz-select>
        </label>
        <label>
          <span>{{ 'log.gcp.trace-id' | i18n }}</span>
          <nz-input-group [nzSuffix]="clearTraceIdTpl" [testId]="'gcp-log-trace-id-input-group'">
            <input
              nz-input
              [(ngModel)]="filters.traceId"
              [placeholder]="'log.gcp.trace-placeholder' | i18n"
              testId="gcp-log-trace-id-input"
            />
            <ng-template #clearTraceIdTpl>
              <span
                *ngIf="filters.traceId"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="filters.traceId = ''"
                testId="gcp-log-trace-id-clear-icon"
              ></span>
            </ng-template>
          </nz-input-group>
        </label>
        <label>
          <span>{{ 'log.gcp.pod-name' | i18n }}</span>
          <nz-input-group [nzSuffix]="clearPodNameTpl" [testId]="'gcp-log-pod-name-input-group'">
            <input
              nz-input
              [(ngModel)]="filters.podName"
              [placeholder]="'log.gcp.pod-placeholder' | i18n"
              testId="gcp-log-pod-name-input"
            />
            <ng-template #clearPodNameTpl>
              <span
                *ngIf="filters.podName"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="filters.podName = ''"
                testId="gcp-log-pod-name-clear-icon"
              ></span>
            </ng-template>
          </nz-input-group>
        </label>
        <label class="gcp-log-keyword">
          <span>{{ 'log.gcp.keyword' | i18n }}</span>
          <nz-input-group [nzSuffix]="clearKeywordTpl" [testId]="'gcp-log-keyword-input-group'">
            <input
              nz-input
              [(ngModel)]="filters.keyword"
              [placeholder]="'log.gcp.keyword-placeholder' | i18n"
              (keyup.enter)="search()"
              testId="gcp-log-keyword-input"
            />
            <ng-template #clearKeywordTpl>
              <span
                *ngIf="filters.keyword"
                nz-icon
                nzType="close-circle"
                nzTheme="fill"
                class="ant-input-clear-icon"
                (click)="filters.keyword = ''"
                testId="gcp-log-keyword-clear-icon"
              ></span>
            </ng-template>
          </nz-input-group>
        </label>
      </div>
    </div>
  </section>

  <nz-alert *ngIf="errorMessage" nzType="error" nzShowIcon [nzMessage]="getErrorMessage()" class="gcp-log-alert" />

  <section class="gcp-log-results" [class.is-loading]="loading" aria-labelledby="gcp-log-results-title">
    <div class="gcp-log-section-heading gcp-log-results-heading">
      <div
        ><h3 id="gcp-log-results-title">{{ 'log.gcp.results-title' | i18n }}</h3
        ><p>{{ 'log.gcp.results-description' | i18n }}</p></div
      >
      <div class="gcp-log-result-meta" *ngIf="hasSearched && !errorMessage"
        ><span class="gcp-log-live-dot"></span>{{ 'log.gcp.current-count' | i18n: { count: items.length } }}</div
      >
    </div>
    <nz-spin [nzSpinning]="loading">
      <div class="gcp-log-table-shell" *ngIf="items.length; else emptyState">
        <nz-table
          #gcpTable
          nzSize="small"
          [nzData]="items"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          [nzScroll]="{ x: '1160px', y: queryCollapsed ? 'calc(100vh - 310px)' : 'calc(100vh - 570px)' }"
          testId="gcp-log-table"
        >
          <thead>
            <tr>
              <th nzWidth="184px">{{ 'log.gcp.timestamp' | i18n }}</th>
              <th nzWidth="116px">{{ 'log.gcp.severity' | i18n }}</th>
              <th nzWidth="170px">{{ 'log.gcp.source' | i18n }}</th>
              <th nzWidth="210px">{{ 'log.gcp.trace-id' | i18n }}</th>
              <th>{{ 'log.gcp.message' | i18n }}</th>
              <th nzWidth="92px" nzRight>{{ 'log.gcp.details' | i18n }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of gcpTable.data; let i = index" class="gcp-log-row" [attr.data-testid]="'gcp-log-row-' + i">
              <td>
                <time class="gcp-log-time" [attr.datetime]="item.timestamp">{{ item.timestamp | date: 'MM-dd HH:mm:ss.SSS' }}</time>
              </td>
              <td>
                <span class="severity-badge" [ngClass]="getSeverityClass(item.severity)">
                  <span class="severity-dot"></span>{{ item.severity || 'DEFAULT' }}
                </span>
              </td>
              <td>
                <div class="gcp-log-source">
                  <strong>{{ item.serviceName || '-' }}</strong>
                  <span>{{ item.podName || '-' }}</span>
                </div>
              </td>
              <td>
                <span class="gcp-log-code" [title]="item.traceId">{{ item.traceId || '-' }}</span>
              </td>
              <td>
                <span class="gcp-log-message" [title]="item.message">{{ getMessagePreview(item.message) }}</span>
              </td>
              <td nzRight>
                <button
                  nz-button
                  nzType="link"
                  class="gcp-log-detail-trigger"
                  type="button"
                  (click)="openDetails(item)"
                  [testId]="'gcp-log-detail-button-' + i"
                >
                  <i nz-icon nzType="code"></i>{{ 'log.gcp.view' | i18n }}
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </nz-spin>
    <ng-template #emptyState>
      <div *ngIf="!loading && !errorMessage" class="gcp-log-empty" testId="gcp-log-empty-state">
        <span class="gcp-log-empty-icon"><i nz-icon [nzType]="hasSearched ? 'file-search' : 'radar-chart'"></i></span>
        <strong>{{ hasSearched ? ('log.gcp.empty' | i18n) : ('log.gcp.initial-hint' | i18n) }}</strong>
        <p>{{ hasSearched ? ('log.gcp.empty-description' | i18n) : ('log.gcp.initial-description' | i18n) }}</p>
      </div>
    </ng-template>
  </section>

  <footer class="gcp-log-pagination" *ngIf="items.length || nextPageToken || pageTokenHistoryLength">
    <span class="gcp-log-page-hint"><i nz-icon nzType="info-circle"></i>{{ 'log.gcp.cursor-hint' | i18n }}</span>
    <div class="gcp-log-page-actions">
      <button
        nz-button
        nzType="default"
        type="button"
        (click)="loadPreviousPage()"
        [disabled]="!pageTokenHistoryLength || loading"
        testId="gcp-log-previous-page-button"
      >
        <i nz-icon nzType="left"></i>{{ 'log.gcp.previous-page' | i18n }}
      </button>
      <button
        nz-button
        nzType="default"
        type="button"
        (click)="loadNextPage()"
        [disabled]="!nextPageToken || loading"
        testId="gcp-log-next-page-button"
      >
        {{ 'log.gcp.next-page' | i18n }}<i nz-icon nzType="right"></i>
      </button>
    </div>
  </footer>

  <div class="gcp-log-drawer-backdrop" *ngIf="selectedLog" (click)="closeDetails()"></div>
  <aside
    class="gcp-log-drawer"
    *ngIf="selectedLog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="gcp-log-detail-title"
    testId="gcp-log-detail-drawer"
  >
    <header class="gcp-log-drawer-header">
      <div>
        <span class="gcp-log-drawer-kicker">{{ 'log.gcp.details' | i18n }}</span>
        <h3 id="gcp-log-detail-title">{{ selectedLog.serviceName || ('log.gcp.runtime-log' | i18n) }}</h3>
      </div>
      <button
        nz-button
        nzType="text"
        nzShape="circle"
        type="button"
        (click)="closeDetails()"
        [attr.aria-label]="'log.gcp.close' | i18n"
        testId="gcp-log-detail-close-button"
      >
        <i nz-icon nzType="close"></i>
      </button>
    </header>
    <div class="gcp-log-drawer-meta">
      <span class="severity-badge" [ngClass]="getSeverityClass(selectedLog.severity)">
        <span class="severity-dot"></span>{{ selectedLog.severity || 'DEFAULT' }}
      </span>
      <time>{{ selectedLog.timestamp | date: 'yyyy-MM-dd HH:mm:ss.SSS' }}</time>
    </div>
    <div class="gcp-log-drawer-content">
      <div class="gcp-log-detail-block">
        <span>{{ 'log.gcp.full-message' | i18n }}</span>
        <pre>{{ selectedLog.message || '-' }}</pre>
      </div>
      <div class="gcp-log-detail-block" *ngIf="selectedLog.labels">
        <span>{{ 'log.gcp.labels' | i18n }}</span>
        <pre>{{ selectedLog.labels | json }}</pre>
      </div>
      <div class="gcp-log-detail-grid">
        <div>
          <span>{{ 'log.gcp.trace-id' | i18n }}</span>
          <code>{{ selectedLog.traceId || '-' }}</code>
        </div>
        <div>
          <span>{{ 'log.gcp.pod-name' | i18n }}</span>
          <code>{{ selectedLog.podName || '-' }}</code>
        </div>
      </div>
    </div>
  </aside>
</section>
